import React, { useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import styles from "./TemporaryPasswordIssued.module.css";
import { useNavigate } from "react-router-dom";

const TemporaryPasswordIssued = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className={styles.main_div}>
        <div className={styles.container_box}>
          <div className={styles.header01}>仮パスワード送信完了</div>
          <div className={styles.header02}>
            Eメールに届いた仮パスワードは２４時間有効です。
          </div>
          <div
            onClick={() => {
              navigate("/login");
            }}
            className={styles.button1}
          >
            ログイン
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TemporaryPasswordIssued;
